import React, {Component} from "react";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class DistinctValueFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lists: this.buildLists(props.options),
            value: [],
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.options !== this.props.options) {
            this.setState({ lists: this.buildLists(this.props.options) });
        }
    }
    buildLists(options) {
        if (!Array.isArray(options)) return [];
        return options.map(v => ({ value: v, label: v == null || v === '' ? '(blank)' : String(v) }));
    }
    resetFilter() {
        this.setState({ value: [] });
    }
    handleChange(selected) {
        const arr = (selected || []).map(o => o.value);
        this.props.onSelect(arr);
        this.setState({ value: selected || [] });
    }
    render() {
        return (
            <ReactMultiSelectCheckboxes
                name={this.props.name}
                value={this.state.value}
                options={this.state.lists}
                isMulti
                isClearable={false}
                styles={reactSelectStyles}
                className="report-listbox"
                onChange={this.handleChange.bind(this)}
                placeholderButtonLabel={this.props.placeholder || "All"}
            />
        );
    }
}

export default DistinctValueFilter;
